<nav aria-label="breadcrumb" role="navigation">
  <ol class="breadcrumb breadcrumb-content-bg">
    <ng-container *ngFor="let item of model">
      <li class="breadcrumb-item" aria-current="page" [ngClass]="{'active': item.is_active === true}" [ngSwitch]="item.is_active">
        <ng-container *ngSwitchCase="false">
          <a [routerLink]="item.link"> {{ item.title }}</a>
        </ng-container>
        <ng-container *ngSwitchCase="true">
          {{ item.title }}
        </ng-container>
      </li>
    </ng-container>
  </ol>
</nav>